import { render, staticRenderFns } from "./create-inairthreshold.vue?vue&type=template&id=9e37e5b8&"
import script from "./create-inairthreshold.vue?vue&type=script&lang=ts&"
export * from "./create-inairthreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports